<script>
    import {
        getContext,
        onDestroy,
        onMount,
        createEventDispatcher,
    } from 'svelte'
    export let label = null
    export let icon = null
    export let alt = ''
    export let active = false
    export let id = null

    const dispatch = createEventDispatcher()
    const currentTab = getContext('currentTab')
    const tabData = getContext('tabData')
    const events = getContext('events')
    const { index } = getContext('setIndex')
    id = id || index ? index() : null
    if (active) {
        currentTab.set(id)
    }
    $: active = currentTab && $currentTab === id
    onMount(() => {
        if (tabData) {
            tabData.update((d) => [...d, { label, icon, alt, id }])
        }
        if (active) {
            currentTab.set(id)
        }
    })
    onDestroy((_) => {
        if (tabData) {
            tabData.update((d) => d.filter((t) => t.id !== id))
        }
    })
    $events[id] = {
        click: () => {
            dispatch('click')
        },
    }
    console.log({ id, active })
</script>

{#if active}
    <slot />
{/if}
